import React, { useEffect, useState, useCallback } from "react";
import { Button, Table, Pagination, Switch, Modal, Drawer } from "antd";
import { MdEdit, MdDelete } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { getBom, deleteBom, setTableData } from "../store/dataSlice";
import DetailTable from "./DetailTable";
import {
  setSelectedBom,
  setSelectedRaw,
  toggleNewEditDialog,
} from "../store/stateSlice";
import RawMaterialForm from "./RawMaterialForm";


const BomTable = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const dispatch = useDispatch();
  const tableData = useSelector((state) => state.rawMaterial.data.tableData);
  const { pageIndex = 1, pageSize = 10 } = tableData || {};
  const edit = useSelector((state) => state.rawMaterial.state.editDialog);
  const data = useSelector((state) => state.rawMaterial.data.bomList?.data);
  const loading = useSelector((state) => state.rawMaterial.data.loading);

  const onEdit = (record) => {
    dispatch(setSelectedBom(record));
    dispatch(toggleNewEditDialog(true));
  };
  const onDelete = (record) => {
    console.log("record", record);
    dispatch(
      deleteBom({
        bom_id: record.bom_id,
      })
    );
  };
  const openDrawer = (record) => {
    setSelectedRecord(record);
    setDrawerVisible(true);
  };
  const fetchData = useCallback(() => {
    dispatch(getBom({ pageIndex, pageSize }));
  }, [pageIndex, pageSize]);
  useEffect(() => {
    fetchData();
  }, [pageIndex, pageSize]);
  const handleTableChange = (pagination) => {
    const { current, pageSize } = pagination;

    dispatch(setTableData({ pageIndex: current, pageSize: pageSize }));
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };
  const handleClose = () => {
    dispatch(toggleNewEditDialog(false)); // Close the modal
  };
  const columns = [
    {
      title: <span className="text-gray-500">Action</span>,
      dataIndex: "action",
      width: 100,
      render: (_, record) => (
        <>
          <div className="flex items-center">
            <span
              onClick={() => onEdit(record)}
              className="text-2xl text-[#096CAE] cursor-pointer"
            >
              <MdEdit />
            </span>
            <span
              onClick={() => onDelete(record)}
              className="text-2xl text-[#cf1623] cursor-pointer"
            >
              <MdDelete />
            </span>
          </div>
        </>
      ),
    },
    {
      title: <span className="text-gray-500">Bom number</span>,
      dataIndex: "bom_number",
      width: 150,
      render: (text, record) => (
        <div
          onClick={() => openDrawer(record)}
          className="cursor-pointer hover:font-extrabold delay-150"
        >
          {text}
        </div>
      ),
    },
    {
      title: <span className="text-gray-500">Order number</span>,
      dataIndex: "order_number",
      width: 150,
      render: (_, record) => record.Po.order_number,
    },
    {
      title: <span className="text-gray-500">Raw Materials</span>,
      dataIndex: "items",
      width: 150,
    },
    {
      title: <span className="text-gray-500">Status</span>,
      dataIndex: "status",
      width: 150,
      render: (status) => (
        <button
          style={{
            color: "white",
            backgroundColor: status ? "green" : "red",
            padding: "2px",
            borderRadius: "4px",
          }}
        >
          {status ? "Done" : "Pending"}
        </button>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        bordered
        scroll={{
          x: 1300,
        }}
        loading={loading}
        onChange={handleTableChange}
        pagination={{
          current: pageIndex,
          pageSize: pageSize,
          showSizeChanger: true,
          pageSizeOptions: [5, 10, 20],
          onShowSizeChange: handleTableChange,
        }}
      />
      <Drawer
        title="Edit Raw Material"
        onClose={handleClose}
        open={edit}
        width={1500}
      >
        <RawMaterialForm type={"edit"} />
      </Drawer>
      <Drawer
        title="Details"
        width={1500}
        onClose={closeDrawer}
        open={drawerVisible}
      >
        <DetailTable record={selectedRecord} />
      </Drawer>

      <Drawer
        title="Details"
        width={1500}
        onClose={closeDrawer}
        open={drawerVisible}
      >
        <DetailTable record={selectedRecord} />
      </Drawer>
    </>
  );
};
export default BomTable;
